import React from "react";
import Setup from "./Setup";
import Snapshot from "./Snapshot";
import Results from "./Results";

export const services: Record<string, () => JSX.Element> = {
  setup: Setup,
  results: Results,
  snapshot: Snapshot
};
